import { __awaiter } from "tslib";
import { useQuery } from '@tanstack/react-query';
export const useGetTags = ({ fetchTags = () => Promise.resolve([]), queryId, tags, topicId, }) => {
    const { data } = useQuery({
        queryKey: [queryId, topicId],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                return yield fetchTags();
            }
            catch (error) {
                console.warn(error);
                throw error;
            }
        }),
        initialData: tags,
        enabled: !tags,
        staleTime: 5 * 60 * 1000,
    });
    return data || [];
};
//# sourceMappingURL=useTags.js.map